<h2 class="ba-spacing-top-h2">{{ 'readmail.history' | i18next }}</h2>
<div i18nRerenderOnLanguageChange></div>
<div class="row mb-3">
    <div class="col-12 col-lg-8">

        <button
                class="ba-btn dropdown-toggle mt-3"
                type="button"
                id="btn-history"
                [attr.aria-expanded]="!isCollapsed"
                [class.collapsed]="isCollapsed"
                (click)="toggleCollapse()"
        >
            {{ 'readmail.show-history' | i18next }}
        </button>

        <div
                id="collapse-history"
                class="collapse pt-1"
                [class.show]="!isCollapsed"
                role="tabpanel"
        >
            <div class="ba-guideline">
                @for (entry of historienElements; track entry.key) {
                    <!-- Start: Wrapper Monat -->
                    <section class="ba-guideline-section">
                        <h3 class="ba-heading">{{ entry.key }}</h3>

                        @for (historyElem of entry.items; track historyElem.datum) {
                            <div class="ba-tile">
                                <pf-nachricht-detail
                                        [nachrichtId]="nachricht.nachrichtId"
                                        [dateTime]="getPostfachFormat(historyElem.datum)"
                                        [sender]="personDisplayService.displayName(historyElem.senderName, historyElem.senderId)"
                                        [autor]="personDisplayService.displayName(historyElem.autorName, historyElem.autorId)"
                                        [empfaenger]="personDisplayService.displayName(historyElem.empfaengerName, historyElem.empfaengerId)"
                                        [text]="historyElem.text"
                                        [betreff]="nachricht.betreff"
                                        [betreffSmall]="true"
                                        [anhaengeNamen]="historyElem.anhaengeNamen"
                                ></pf-nachricht-detail>
                            </div>

                        }
                    </section>
                    <!-- Ende: Wrapper Monat -->
                }

            </div>
        </div>

    </div>
</div>

<a href="javascript: void(0)" class="ba-link-icon ba-icon-download" id="link-download"
   (click)="downloadHistory()">{{ 'readmail.download-history' | i18next }} (PDF)</a>
